@if (chartConfig?.title) {
  <div class="title">
    {{ chartConfig.title }}
  </div>
}

<div class="wrapper-chart">
  <canvas #canvas></canvas>
</div>
